// eslint-disable-next-line quotes
import hcOffcanvasNav from "hc-offcanvas-nav";
// eslint-disable-next-line quotes
import headerSticky from "../plugins/headerSticky";

// eslint-disable-next-line quotes
import AOS from "aos";

export default {
  init() {
    // JavaScript to be fired on all pages
    headerSticky();

    AOS.init({
      once: true,
      offset: -300,
    });

    // eslint-disable-next-line quotes
    new hcOffcanvasNav("#main-nav", {
      disableAt: 700,
      // disableAt: false,
      width: 377,
      // eslint-disable-next-line quotes
      customToggle: ".toggle",
      // eslint-disable-next-line quotes
      levelOpen: "overlap",
      // navTitle: {},
      levelTitles: false,
      levelTitleAsBack: false,
      // closeOpenLevels: true,
      // closeActiveLevel: true,
      disableBody: true,
      // eslint-disable-next-line quotes
      position: "left",
      // eslint-disable-next-line quotes
      // labelBack: "กลับสู่เมนูหลัก",
      // eslint-disable-next-line quotes
      // pushContent: ".wrap",
    });

    // eslint-disable-next-line quotes
    $(".top-header .column-header .ele-lang")
      .clone()
      // eslint-disable-next-line quotes
      .appendTo(".nav-container");

    // Wait for the page to fully load
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // eslint-disable-next-line quotes
    // document.addEventListener("DOMContentLoaded", function () {
    //   // eslint-disable-next-line quotes
    //   const cards = document.querySelectorAll(".content-card");
    //   // Apply animation to each card with a delay
    //   cards.forEach((card, index) => {
    //     card.style.animationDelay = `${index * 300}ms`; // Use backticks (`) for string interpolation
    //   });
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js